import Mousetrap from 'mousetrap';
import $ from 'jquery';

export default {

    // the payload is set via a 'Syn.libs.Hotkeys.payload = {}` call in base.html.twig
    payload: [],

    init() {
        // serve as a binding factory for shortcuts injecting functionality
        $.each(this.payload, function(i, e) {
            Mousetrap.bind(e.binding, function () {
                return (new Function(e.function))();
            });
        });
        Syn.libs.Hotkeys = this;

        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });

        let crudItemOffset = parseInt(params['crud-item-offset']);
        if(crudItemOffset === -1) {
            Syn.addToast(
                Syn.trans('hotkeys.general.prev_navigated', [], 'SyndustryCommonBundle'),
                'info',
                'fa-chevron-left'
            );
        }

        if(crudItemOffset === 1) {
            Syn.addToast(
                Syn.trans('hotkeys.general.next_navigated', [], 'SyndustryCommonBundle'),
                'info',
                'fa-chevron-right'
            );
        }
    },

    changeItem(direction) {
        $.ajax({
            url: Syn.generateURL('crud_sibling_check', {'direction' : direction}),
            method: 'POST',
            data: JSON.stringify({route: Syn.route, route_params: Syn.route_params}),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function(data){
                window.location = data.redirect;
            },
            error: function(errMsg) {
                Syn.addToast(
                    Syn.trans('hotkeys.general.'+direction+'_not_found', [], 'SyndustryCommonBundle'),
                    'warning', 'fa-times'
                );
            }
        });
    }
}